import { memo } from 'react';

import { useController, useFormContext } from 'react-hook-form';

import {
  AsyncAutocomplete as BaseAsyncAutocomplete,
  AsyncAutocompleteProps as BaseAsyncAutocompleteProps
} from '@ui';

export interface AsyncAutocompleteProps
  extends Omit<BaseAsyncAutocompleteProps, 'setValue' | 'fieldValue'> {
  name: string;
}

/**
 * More features To support, below two are used only in term
 * - [ ]  includeDynamicOption
 * - [ ]  afterSelection and afterCustomSelection
 */

const AsyncAutocomplete: React.FC<AsyncAutocompleteProps> = memo(
  ({ name, ...rest }: AsyncAutocompleteProps) => {
    const { setValue: _setValue, control } = useFormContext();
    const { field } = useController({ name, control });

    const setValue = (value: string) => {
      _setValue(name, value, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true
      });
    };

    return (
      <BaseAsyncAutocomplete
        {...rest}
        setValue={setValue}
        fieldValue={field?.value ?? null}
      />
    );
  }
);

export { AsyncAutocomplete };
